import { productUrlPrefix } from './url-utils';

export const membershipProfileUrl = ({ product = 'waybetter' }) => {
  return `/profile${productUrlPrefix(product)}/membership`;
};
